import { ProfileModel } from '@pukka/api';
import { format } from 'date-fns';

import { pushClevertapEvent } from '.';

function comparisonObj(outlets: number, profile: ProfileModel.Response | undefined) {
  return {
    'Business ID': profile?.business?.id,
    'User Email': profile?.email,
    Timestamp: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
    Outlets: outlets,
  };
}

function outletComparisonEvent(outlets: number, profile: ProfileModel.Response | undefined) {
  pushClevertapEvent('Outlet Comparison', comparisonObj(outlets, profile));
}

function editOutletComparisonEvent(outlets: number, profile: ProfileModel.Response | undefined) {
  pushClevertapEvent('Edit Outlet Comparison', comparisonObj(outlets, profile));
}

export { outletComparisonEvent, editOutletComparisonEvent };
